import clsx from 'clsx';
import { TimelineStep, TimelineStepStatus } from '@interfaces/models/timeline';
import Icon from '@components/atoms/icon/icon';
import styles from '../product-timeline.module.scss';

// The cards that have status showed at the top
// Ex: CANCELLED / ACTION NEEDED / IN PROGRESS
const STATUSES_TO_SHOW_LABEL: TimelineStepStatus[] = ['cancelled', 'pending', 'ongoing'];

const OutlineView: React.FC<{
  step: TimelineStep;
}> = ({ step }) => {
  const { status, nextStepStatus } = step;

  const lastStep = nextStepStatus === 'none';

  const lastStepStyle = lastStep ? styles.ordersSales__mainRight__steps__step__last : '';

  const lineStyles: Record<TimelineStepStatus, string> = {
    ongoing: styles.ordersSales__mainRight__steps__step__ongoingLine,
    cancelled: styles.ordersSales__mainRight__steps__step__cancelledLine,
    done: styles.ordersSales__mainRight__steps__step__doneLine,
    pending: styles.ordersSales__mainRight__steps__step__pendingLine,
    upcoming: styles.ordersSales__mainRight__steps__step__upcomingLine,
    none: '',
  };

  const isCurrentCardShowStatusBox = STATUSES_TO_SHOW_LABEL.includes(status);
  const isNextCardShowStatusBox = STATUSES_TO_SHOW_LABEL.includes(nextStepStatus);

  let lineStyle = lineStyles[nextStepStatus];

  if (isCurrentCardShowStatusBox) {
    lineStyle = clsx(
      lineStyle,
      styles.ordersSales__mainRight__steps__step__hasStatusCapsule__dot,
      styles.ordersSales__mainRight__steps__step__hasStatusCapsule__lineToNormalCard,
      {
        [styles.ordersSales__mainRight__steps__step__hasStatusCapsule__lineToCardHasStatusCapsule]:
          isNextCardShowStatusBox,
      },
    );
  }

  if (isNextCardShowStatusBox) {
    lineStyle = clsx(lineStyle, styles.ordersSales__mainRight__steps__step__line);
  }

  switch (status) {
    case 'ongoing':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__ongoing, lastStepStyle, lineStyle)} />;
    case 'done':
      if (lastStep === true) {
        return (
          <div className={clsx(styles.ordersSales__mainRight__steps__step__doneWithIcon, lastStepStyle, lineStyle)}>
            <Icon
              className={styles.ordersSales__mainRight__steps__step__doneWithIcon__icon}
              name="checkmark"
              ariaHidden
            />
          </div>
        );
      } else {
        return <div className={clsx(styles.ordersSales__mainRight__steps__step__done, lastStepStyle, lineStyle)} />;
      }
    case 'cancelled':
      return (
        <div className={clsx(styles.ordersSales__mainRight__steps__step__cancelled, lastStepStyle, lineStyle)}>
          <Icon
            className={styles.ordersSales__mainRight__steps__step__cancelled__icon}
            name="cross-x-thick"
            ariaHidden
          />
        </div>
      );
    case 'upcoming':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__upcoming, lastStepStyle, lineStyle)} />;
    case 'pending':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__pending, lastStepStyle, lineStyle)} />;
    case 'none':
      return <></>;
  }
};

export default OutlineView;
